module.exports = __webpack_public_path__ + "img/Trophy Cup Table11.ae1e6ebf.jpg";